import React from 'react';
export function InboxIcon(props) {
  var className = props && props.className ? 'wink-icon ' + props.className : 'wink-icon';
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    focusable: "false",
    "aria-hidden": "true"
  }, props, {
    className: className
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21 11h-5a1 1 0 00-.895.553L14.382 13H9.618L8.9 11.553A1 1 0 008 11H3a1 1 0 00-1 1v6a3 3 0 003 3h14a3 3 0 003-3v-6a1 1 0 00-1-1zm-1 7a1 1 0 01-1 1H5a1 1 0 01-1-1v-5h3.382l.723 1.447A1 1 0 009 15h6a1 1 0 00.895-.553L16.618 13H20v5zM5 9h14a1 1 0 100-2H5a1 1 0 000 2zM6 5h12a1 1 0 100-2H6a1 1 0 000 2z"
  }));
}